
import Fancybox from '../../../src/js/shared/fancybox';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const newsletterPopup = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.initPopup();
		},

		cacheDOM: function() {
			this.$popup = $('.js-newsletter-popup');
		},

		bindEvents: function() {
			$(document).on('submit', '.js-newsletter-popup form', this.handleSubmit.bind(this));
			document.addEventListener('keydown', this.handleKeyDown.bind(this));
		},

		initPopup: function() {
			Fancybox.initializefancyboxPopup('.js-popup-opener', '.js-newsletter-popup', 'newsletter-popup-class');
		},

		handleKeyDown: function(e) {
			console.log(e.key);
			if (e.key !== 'Escape') {
				return;
			}
			const $closeBtn = $('.fancybox-close-small');
			if ($closeBtn.length) {
				$closeBtn.trigger('click');
			}
		},

		handleSubmit: function(e) {
			e.preventDefault();

			const $form = $(e.currentTarget);
			const $submitBtn = $form.find('[type="submit"]');
			const $loader = $('<div class="newsletter-popup__loader"></div>');

			$submitBtn.prop('disabled', true).before($loader);

			$.ajax({
				type: 'POST',
				url: window.location.href,
				data: $form.serialize(),
				success: function(html) {
					const doc = new DOMParser().parseFromString(html, 'text/html');
					const responseEl = doc.querySelector('.mc4wp-response');

					$loader.remove();
					$form.find('.mc4wp-response').remove();

					if (responseEl) {
						$form.append(responseEl.outerHTML);
					}

					$submitBtn.prop('disabled', false);
				},
				error: function() {
					$loader.remove();
					$submitBtn.prop('disabled', false);
				},
			});
		},

	};

	newsletterPopup.init();
});
